import { unwrap } from "@sagot/api-client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../../../session/session-provider";
import { useWorkspaceId } from "../../../session/workspace-context";
import { engageKeys } from "../shared/engage-keys";
import type { LeadRoutingUpdate } from "./lead-types";

function useRoutingKey() {
  return [...engageKeys.leads(useWorkspaceId()), "routing"] as const;
}

/** `GET /v1/settings/leads`: who new leads go to and the shared leads inbox. */
export function useLeadRouting(enabled: boolean) {
  const api = useApi();
  return useQuery({ queryKey: useRoutingKey(), enabled, queryFn: () => unwrap(api.GET("/v1/settings/leads")) });
}

export function useSaveLeadRouting() {
  const api = useApi();
  const client = useQueryClient();
  const key = useRoutingKey();
  return useMutation({
    mutationFn: (body: LeadRoutingUpdate) => unwrap(api.PUT("/v1/settings/leads", { body })),
    onSuccess: (saved) => {
      client.setQueryData(key, saved);
    },
  });
}
